export default "{\n  bar: number\n  bottom: number\n  footer: number\n  footerInset: number\n  left: number\n  right: number\n  top: number\n}\n";